import React, { useEffect, useState } from 'react';
import Layout from '../components/navbar/Layout';
import TabComponent from '../components/TabComponent'; // TabComponent 경로를 수정해주세요
import MyPageTab1 from '../components/myPage/MyPageTab1';
import MyPageTab2 from '../components/myPage/MyPageTab2';
import MyPageTab3 from '../components/myPage/MyPageTab3';
import { useLocation, useNavigate } from 'react-router-dom';
import { MyPageUrl } from '../url/poenUrl';
import LoginRedirect from '../components/LoginRedirect';
import UnauthorizedMessage from '../components/UnauthorizedMessage';

function MyPage() {
  const [activeTab, setActiveTab] = useState<number>(0);
  const [isAuthorized, setIsAuthorized] = useState<boolean>(true);
  const navigate = useNavigate();
  const location = useLocation();

  // 탭 데이터 정의
  const tabs = [
    { title: '문의이력', content: <MyPageTab1 /> },
    { title: '회원정보 수정', content: <MyPageTab2 /> },
    { title: '회원탈퇴', content: <MyPageTab3 /> },
  ];

  // activeTab 값을 URL 쿼리에서 읽어오기
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const activeTabFromUrl = parseInt(queryParams.get('activeTab') || '0', 10);
    setActiveTab(activeTabFromUrl);

    // 권한 확인
    const storedPermissions = localStorage.getItem('permissions');
    if (storedPermissions) {
      if (storedPermissions === 'ADMIN') {
        setIsAuthorized(false); // ADMIN은 접근 불가
      } else {
        setIsAuthorized(true); // 다른 권한은 접근 허용
      }
    }
  }, [location.search]);

  const handleTabChange = (index: number) => {
    // activeTab에 따라 URL을 다르게 설정
    navigate(`${MyPageUrl}?activeTab=${index}`);
  };

  return (
    <Layout>
      <LoginRedirect />
      {isAuthorized === null ? null : !isAuthorized ? (
        <UnauthorizedMessage />
      ) : (
        <TabComponent
          tabs={tabs}
          activeTab={activeTab}
          onTabChange={handleTabChange}
        />
      )}
    </Layout>
  );
}

export default MyPage;
